import React, { Fragment, useState, useEffect } from 'react';
import { Table } from "reactstrap";

const TableChart = (props) => {
    let { dashboard, data } = props;
    let dashboardType = parseInt(dashboard[2]);
    let dashboardName = dashboard[1];
    let chartdata = [];
    let headerval = data[0];
    let datatable = data[1];
    let options = {};
    return (
        <div>
            <div className='table-chart-continer'>
                <Table className="mb-0 overflow-scroll">
                    {headerval.length > 0 && <thead>
                        <tr>
                            <th>#</th>
                            <th>{headerval[0]}</th>
                            <th>{headerval[1]}</th>
                        </tr>
                    </thead>
                    }
                    {
                        datatable.length > 0 && <tbody>
                            {
                                datatable.map((dataItem, i) => {
                                    return (
                                        <tr>
                                            <th scope="row">{i + 1}</th>
                                            <td>{dataItem[0]}</td>
                                            <td>{dataItem[1]}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    }
                </Table>
            </div>
        </div>
    )
};

export default TableChart;